import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Image from '@plone/volto/components/theme/Image/Image';
import './Banner.scss';
import usFlagSmall from './images/us_flag_small.png';
import iconDotGov from './images/icon-dot-gov.svg';
import iconHttps from './images/icon-https.svg';

const Banner = ({ flagSrc, dotGovIconSrc, httpsIconSrc }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <section
      className="usa-banner"
      aria-label="Official website of the United States government"
    >
      <div className="usa-accordion">
        <header className="usa-banner__header">
          <div className="usa-banner__inner">
            <div className="grid-col-auto">
              <Image
                aria-hidden="true"
                className="usa-banner__header-flag"
                src={flagSrc}
                alt=""
              />
            </div>
            <div
              className="grid-col-fill tablet:grid-col-auto"
              aria-hidden="true"
            >
              <p className="usa-banner__header-text">
                An official website of the United States government
              </p>
            </div>
            <button
              type="button"
              className="usa-accordion__button usa-banner__button"
              aria-expanded={isOpen}
              aria-controls="gov-banner-default"
              onClick={() => setIsOpen((prev) => !prev)}
            >
              <span className="usa-banner__button-text">
                Here's how you know
              </span>
            </button>
          </div>
        </header>
        <div
          className={`usa-banner__content usa-accordion__content${
            isOpen ? ' is-open' : ''
          }`}
          id="gov-banner-default"
        >
          <div className="grid-row grid-gap-lg">
            <div className="usa-banner__guidance tablet:grid-col-6">
              <Image
                className="usa-banner__icon usa-media-block__img"
                src={dotGovIconSrc}
                alt=""
                aria-hidden="true"
              />
              <div className="usa-media-block__body">
                <p>
                  <strong>Official websites use .gov</strong>
                  <br />A <strong>.gov</strong> website belongs to an official
                  government organization in the United States.
                </p>
              </div>
            </div>
            <div className="usa-banner__guidance tablet:grid-col-6">
              <Image
                className="usa-banner__icon usa-media-block__img"
                src={httpsIconSrc}
                alt=""
                aria-hidden="true"
              />
              <div className="usa-media-block__body">
                <p>
                  <strong>Secure .gov websites use HTTPS</strong>
                  <br />A <strong>lock</strong> or <strong>https://</strong>{' '}
                  means you've safely connected to the .gov website. Share
                  sensitive information only on official, secure websites.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

Banner.propTypes = {
  flagSrc: PropTypes.string,
  dotGovIconSrc: PropTypes.string,
  httpsIconSrc: PropTypes.string,
};

Banner.defaultProps = {
  flagSrc: usFlagSmall,
  dotGovIconSrc: iconDotGov,
  httpsIconSrc: iconHttps,
};

export default Banner;
